export function GlassFilter() {
	return (
		<svg width="0" height="0" className="absolute" aria-hidden>
			<filter id="glass-refract" colorInterpolationFilters="sRGB">
				<feTurbulence
					type="fractalNoise"
					baseFrequency="0.012"
					numOctaves="2"
					seed="7"
					result="noise"
				/>
				<feDisplacementMap
					in="SourceGraphic"
					in2="noise"
					scale="14"
					xChannelSelector="R"
					yChannelSelector="G"
				/>
			</filter>
		</svg>
	)
}
